import React from 'react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-20 bg-warm-dark text-cream text-center px-4" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-13">
          Tu vida real no necesita más dietas. <br data-id="element-14" />
          Necesita un sistema.
        </h2>
        <p className="text-xl text-cream/80 mb-10 max-w-2xl mx-auto" data-id="element-15">
          Empieza hoy mismo a cerrar el portal de los antojos y recupera tus
          tardes.
        </p>
        <Button variant="primary" size="lg" className="bg-cream text-warm-dark hover:bg-white hover:text-terracotta shadow-none" onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-16">
          Empezar Ahora
        </Button>
      </div>
    </section>;
}